import { SkinProblemFrequency } from "./v1";

export const skinProblemFrequencyOptions = Object.entries(SkinProblemFrequency)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
